import CommunicationTaskForm from "./communication-task-form/communication-task-form";
import CommunicationFiltersForm from "./communication-filters-form/communication-filters-form";

const CommunicationForms = {
  Task: CommunicationTaskForm,
  Filters: CommunicationFiltersForm,
};

export default CommunicationForms;
